<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-body">
          <h5 class="panel-title">
            <span class="title"></span>
          </h5>
          <div class="row">
            <DataTable
              :value="usuarioContribuinteList"
              :paginator="true"
              :rows="10"
              :autoLayout="true"
            >
              <template #header>
                <div
                  style="line-height:1.87em"
                  class="p-clearfix"
                >Lista de Usuários com acesso a inscrição selecionada.</div>
              </template>
              <Column field="usuario.pessoa.numeroDocumentoJuridico" header="CPF/CNPJ"></Column>
              <Column field="usuario.pessoa.nomeGeral" header="Nome"></Column>
              <Column field="usuario.pessoa.numeroDocumentoJuridico" header="Login"></Column>
            </DataTable>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-2 mb-2">
              <span class="p-fluid">
                <Button
                  label="Transferir para outra Inscrição"
                  @click="novoContr()"
                  icon="pi pi-plus"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="displayRemove" :style="{width: '30vw'}" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" />
        <Button label="Não" icon="pi pi-times" @click="close" class="p-button-secondary" />
      </template>
    </Dialog>
    <Dialog
      header="Inscrições Contribuinte"
      :visible.sync="showCadastroContribuinte"
      :modal="true"
      :closable="false"
      :style="{width: '60vw'}"
    >
      <div class="scrolable-dialog">
        <error-list :erros="erros" />
        <div class="row">
          <DataTable :value="contrList" :paginator="true" :rows="10" :autoLayout="true">
            <template #header>
              <div
                style="line-height:1.87em"
                class="p-clearfix"
              >Lista de Inscrições do Contribuinte.</div>
            </template>
            <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Selecionar">
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-check"
                  @click="alterarContribuinte(slotProps.data.id)"
                ></Button>
              </template>
            </Column>
            <Column field="idPessoa.numeroDocumentoJuridico" header="CPF/CNPJ"></Column>
            <Column field="idPessoa.nomeGeral" header="Nome"></Column>
            <Column field="inscricaoMunicipal" header="Inscrição Municipal"></Column>
            <Column field="idSituacaoCadastro.nomeSituacao" header="Situação"></Column>
          </DataTable>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="hideNovoContribuinte()"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import UsuarioContribuinteService from "../services/tributario/usuario.contribuinte.service";

export default {
  name: "usuarioContribuinte",
  data() {
    return {
      erros: [],
      loading: false,
      currentUser: null,
      usuarioContribuinteList: null,
      contrList: null,
      idUsuarioContr: null,
      displayRemove: false,
      showCadastroContribuinte: false,
      selectedContribuinte: null,
      filteredContribuinte: null
    };
  },
  created() {
    this.processando(true);
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    pesquisar() {
      if (this.currentUser.contribuinte.idContribuinte) {
        this.processando(true);
        UsuarioContribuinteService.findAllByContribuinte(
          this.currentUser.usuario.idCliente,
          this.currentUser.contribuinte.idContribuinte
        )
          .then(response => {
            this.usuarioContribuinteList = response.data;
          })
          .then(() => {
            this.processando(false);
          });
      }
    },
    novoContr() {
      this.processando(true);
      UsuarioContribuinteService.findContribuinteByDocumento(
        this.currentUser.usuario.idCliente,
        this.currentUser.contribuinte.documento
      )
        .then(response => {
          this.contrList = response.data;
        })
        .then(() => {
          this.processando(false);
          this.selectedContribuinte = null;
          this.showCadastroContribuinte = true;
          this.displayRemove = false;

          this.erros = [];
        });
    },
    alterarContribuinte(novoIdContribuinte) {
      
      if (novoIdContribuinte == this.currentUser.contribuinte.idContribuinte) {
        this.$toast.add({
          severity: "warn",
          summary: 'Não é possível transferir para mesma inscrição!'
        });
        return;
      }
      this.processando(true);
      UsuarioContribuinteService.transferirInscricao(
        this.currentUser.usuario.idCliente,
        novoIdContribuinte,
        this.currentUser.contribuinte.idContribuinte
      )
        .then(
          response => {
            console.log(response);
            this.pesquisar();
            this.$toast.add({
              severity: "success",
              summary: "Operação efetuada com sucesso"
            });
          },
          error => {
            let errorMessage = "Houve um problema ao transferir!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    hideNovoContribuinte() {
      this.showCadastroContribuinte = false;
    },
    salvarNovoContribuinte() {
      this.processando(true);
      UsuarioContribuinteService.save(
        this.currentUser.contribuinte.idUsuario,
        this.selectedContribuinte.id
      )
        .then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Registro efetuado com sucesso"
            });
          },
          error => {
            let errorMessage = "Houve um problema ao salvar!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        )
        .then(() => {
          this.pesquisar();
          this.processando(false);
          this.showCadastroContribuinte = false;
        });
    },
    confirmRemove(idUsuarioContr) {
      this.idUsuarioContr = idUsuarioContr;
      this.displayRemove = true;
    },
    remove() {
      this.processando(true);
      UsuarioContribuinteService.remove(this.idUsuarioContr)
        .then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Registro removido com sucesso"
            });
          },
          error => {
            let errorMessage = "Houve um problema ao remover!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        )
        .then(() => {
          this.pesquisar();
          this.processando(false);
          this.displayRemove = false;
        });
    },
    close() {
      this.idUsuarioContr = null;
      this.displayRemove = false;
    },
    searchContribuinte(event) {
      setTimeout(async () => {
        let idConta = this.currentUser.usuario.idConta;
        let idCliente = this.currentUser.usuario.idCliente;
        this.filteredContribuinte = await UsuarioContribuinteService.findAllByConttribuinteFiltro(
          idCliente,
          idConta,
          event.query
        );
      }, 250);
    }
  }
};
</script>

<style scoped>
</style>